

// import React, { useEffect, useRef, useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import { Typography, Box, Skeleton, useTheme, useMediaQuery } from "@mui/material";
// import { ArrowLeft, ArrowRight } from "iconsax-react";

// const KIA_EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

// export default function VerticalCarousel({ 
//   data, 
//   imageOnLeft = true,
//   textWidth = "60%",
//   imageWidth = "40%"
// }) {
//   console.log("VerticalCarousel data:", data);
  
//   /* ---------------- HOOKS ---------------- */
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
//   const swiperRef = useRef(null);
//   const containerRef = useRef(null);
//   const [active, setActive] = useState(0);
//   const [progress, setProgress] = useState(0);
//   const [loaded, setLoaded] = useState(false);
//   const [isInView, setIsInView] = useState(false);
//   const [swiperSlidesPerView, setSwiperSlidesPerView] = useState(3);
//   const [swiperSpaceBetween, setSwiperSpaceBetween] = useState(25);

//   /* ---------------- SAFE DATA ---------------- */
//   const slides = Array.isArray(data?.carData) ? data.carData : [];
//   const total = slides.length;
//   const mediaSrc = slides[active]?.media || "";
//   const isVideo = mediaSrc.toLowerCase().endsWith(".mp4");

//   /* ---------------- RESPONSIVE SETTINGS ---------------- */
//   useEffect(() => {
//     if (isMobile) {
//       setSwiperSlidesPerView(2);
//       setSwiperSpaceBetween(15);
//     } else if (isTablet) {
//       setSwiperSlidesPerView(2.5);
//       setSwiperSpaceBetween(20);
//     } else {
//       setSwiperSlidesPerView(3);
//       setSwiperSpaceBetween(25);
//     }
//   }, [isMobile, isTablet]);

//   /* ---------------- EFFECTS ---------------- */
//   useEffect(() => {
//     if (active >= total && total > 0) {
//       setActive(0);
//     }
//   }, [active, total]);

//   useEffect(() => {
//     if (!containerRef.current) return;
//     const observer = new IntersectionObserver(
//       ([entry]) => setIsInView(entry.isIntersecting),
//       { threshold: 0.2 } // Reduced threshold for mobile
//     );
//     observer.observe(containerRef.current);
//     return () => observer.disconnect();
//   }, []);

//   // Auto-play logic with responsive interval
//   useEffect(() => {
//     if (!isInView || total === 0) return;
    
//     const interval = isMobile ? 150 : isTablet ? 130 : 120;
//     const increment = isMobile ? 8 : isTablet ? 6 : 5;
    
//     const timer = setInterval(() => {
//       setProgress((p) => {
//         if (p >= 100) {
//           const nextSlide = (active + 1) % total;
//           setActive(nextSlide);
//           setProgress(0);
//           setLoaded(false);
          
//           if (swiperRef.current) {
//             let swiperPosition = nextSlide;
//             if (nextSlide > total - swiperSlidesPerView && total > swiperSlidesPerView) {
//               swiperPosition = total - swiperSlidesPerView;
//             }
//             swiperRef.current.slideTo(swiperPosition, 600);
//           }
//           return 0;
//         }
//         return p + increment;
//       });
//     }, interval);
    
//     return () => clearInterval(timer);
//   }, [isInView, total, active, swiperSlidesPerView, isMobile, isTablet]);

//   /* ---------------- NAVIGATION FUNCTIONS ---------------- */
//   const goNext = () => {
//     const nextSlide = (active + 1) % total;
//     setActive(nextSlide);
//     setProgress(0);
//     setLoaded(false);
    
//     if (swiperRef.current) {
//       let swiperPosition = nextSlide;
//       if (nextSlide > total - swiperSlidesPerView && total > swiperSlidesPerView) {
//         swiperPosition = total - swiperSlidesPerView;
//       }
//       swiperRef.current.slideTo(swiperPosition, 500);
//     }
//   };

//   const goPrev = () => {
//     const prevSlide = (active - 1 + total) % total;
//     setActive(prevSlide);
//     setProgress(0);
//     setLoaded(false);
    
//     if (swiperRef.current) {
//       let swiperPosition = prevSlide;
//       if (prevSlide > total - swiperSlidesPerView && total > swiperSlidesPerView) {
//         swiperPosition = total - swiperSlidesPerView;
//       }
//       swiperRef.current.slideTo(swiperPosition, 500);
//     }
//   };

//   const handleSlideClick = (index) => {
//     setActive(index);
//     setProgress(0);
//     setLoaded(false);
    
//     if (swiperRef.current) {
//       let swiperPosition = index;
//       if (index > total - swiperSlidesPerView && total > swiperSlidesPerView) {
//         swiperPosition = total - swiperSlidesPerView;
//       }
//       swiperRef.current.slideTo(swiperPosition, 500);
//     }
//   };

//   const handleSwiperChange = (swiper) => {
//     const swiperIndex = swiper.activeIndex;
//     let actualSlideIndex = swiperIndex;
    
//     if (swiperIndex >= total - swiperSlidesPerView && total > swiperSlidesPerView) {
//       actualSlideIndex = swiperIndex;
//       if (actualSlideIndex >= total) {
//         actualSlideIndex = total - 1;
//       }
//     }
    
//     if (actualSlideIndex !== active) {
//       setActive(actualSlideIndex);
//       setProgress(0);
//       setLoaded(false);
//     }
//   };

//   /* ---------------- GUARD ---------------- */
//   if (!data || total === 0) return null;

//   /* ---------------- UI COMPONENTS ---------------- */
//   const MediaSection = (
//     <Box 
//       position="relative" 
//       width="100%" 
//       height="100%" 
//       minHeight={{ xs: 300, sm: 350, md: 400 }}
//       display="flex"
//       alignItems="center"
//       justifyContent="center"
//       sx={{
//         overflow: "hidden"
//         // REMOVED: borderRadius: { xs: "12px", md: "16px" }
//       }}
//     >
//       {!loaded && (
//         <Skeleton
//           variant="rectangular"
//           width="100%"
//           height="100%"
//           sx={{ 
//             position: "absolute", 
//             zIndex: 2
//             // REMOVED: borderRadius: { xs: "12px", md: "16px" }
//           }}
//         />
//       )}
//       {isVideo ? (
//         <video
//           key={`video-${active}`}
//           src={mediaSrc}
//           autoPlay
//           loop
//           muted
//           playsInline
//           onCanPlayThrough={() => setLoaded(true)}
//           onError={() => setLoaded(true)}
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             opacity: loaded ? 1 : 0,
//             transition: `opacity 0.8s ${KIA_EASE}`
//             // REMOVED: borderRadius: "inherit"
//           }}
//         />
//       ) : (
//         <Box
//           component="img"
//           key={`image-${active}`}
//           src={mediaSrc}
//           loading="lazy"
//           onLoad={() => setLoaded(true)}
//           onError={() => setLoaded(true)}
//           sx={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             opacity: loaded ? 1 : 0,
//             transition: `opacity 0.8s ${KIA_EASE}`
//             // REMOVED: borderRadius: "inherit"
//           }}
//         />
//       )}
//     </Box>
//   );

//   const ContentSection = (
//     <Box 
//       flex="1" 
//       p={{ xs: 2, sm: 3, md: 4 }}
//       sx={{
//         width: "100%",
//         height: "100%",
//         display: "flex",
//         flexDirection: "column",
//         justifyContent: "center"
//       }}
//     >
//       {/* Subtitle */}
//       <Typography
//         color="gray"
//         letterSpacing={{ xs: 1, md: 2 }}
//         fontFamily="KIAbodyLatinbasic_Bold"
//         fontSize={{ xs: "0.75rem", sm: "0.875rem", md: "1rem" }}
//         mb={{ xs: 0.5, md: 1 }}
//       >
//         {data.sub}
//       </Typography>

//       {/* Title */}
//       <Typography
//         fontFamily="KIAbodyLatinbasic_Bold"
//         sx={{ 
//           fontSize: { xs: "18px", sm: "22px", md: "clamp(22px,4vw,30px)" }, 
//           my: { xs: 0.5, sm: 1, md: 1.5 },
//           lineHeight: { xs: 1.3, md: 1.4 }
//         }}
//       >
//         {data.title}
//       </Typography>

//       {/* Description */}
//       <Typography
//         fontFamily="KIAbodyLatinbasic_Regular"
//         lineHeight={{ xs: 1.5, md: 1.8 }}
//         mb={{ xs: 2, md: 3 }}
//         fontSize={{ xs: "0.875rem", sm: "0.9375rem", md: "1rem" }}
//       >
//         {data.data}
//       </Typography>

//       {/* Counter + arrows */}
//       <Box 
//         display="flex" 
//         alignItems="center" 
//         gap={{ xs: 1.5, md: 2 }} 
//         mb={{ xs: 2, md: 3 }}
//         flexWrap="wrap"
//       >
//         <Typography sx={{ 
//           px: { xs: 1.5, md: 2 }, 
//           py: { xs: 0.25, md: 0.5 }, 
//           borderRadius: 20, 
//           background: "#f2f2f2",
//           fontFamily: "KIAbodyLatinbasic_Bold",
//           fontSize: { xs: "0.75rem", md: "0.875rem" }
//         }}>
//           {active + 1}/{total}
//         </Typography>

//         <Box display="flex" gap={{ xs: 1, md: 1.5 }}>
//           <Box 
//             onClick={goPrev}
//             sx={{ 
//               cursor: "pointer", 
//               padding: { xs: "4px", md: "6px" },
//               borderRadius: "50%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               "&:hover": { 
//                 backgroundColor: "rgba(0,0,0,0.05)" 
//               }
//             }}
//           >
//             <ArrowLeft size={isMobile ? 20 : 24} />
//           </Box>
//           <Box 
//             onClick={goNext}
//             sx={{ 
//               cursor: "pointer", 
//               padding: { xs: "4px", md: "6px" },
//               borderRadius: "50%",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               "&:hover": { 
//                 backgroundColor: "rgba(0,0,0,0.05)" 
//               }
//             }}
//           >
//             <ArrowRight size={isMobile ? 20 : 24} />
//           </Box>
//         </Box>
//       </Box>

//       {/* Vertical Swiper */}
//       <Box sx={{ 
//         height: { xs: 220, sm: 250, md: 300 }, 
//         width: "100%",
//         overflow: "hidden"
//       }}>
//         <Swiper
//           direction="vertical"
//           slidesPerView={swiperSlidesPerView}
//           spaceBetween={swiperSpaceBetween}
//           modules={[Navigation]}
//           onSwiper={(s) => {
//             swiperRef.current = s;
//           }}
//           onSlideChange={handleSwiperChange}
//           observer={true}
//           observeParents={true}
//           initialSlide={0}
//           style={{ 
//             height: "100%", 
//             width: "100%",
//             paddingRight: isMobile ? "10px" : "0"
//           }}
//           touchRatio={0.8}
//           resistanceRatio={0.5}
//         >
//           {slides.map((item, i) => (
//             <SwiperSlide key={i}>
//               <Box 
//                 pl={{ xs: 1.5, md: 2 }} 
//                 pr={{ xs: 0.5, md: 1 }}
//                 py={{ xs: 0.5, md: 1 }}
//                 position="relative" 
//                 width="100%"
//                 sx={{ 
//                   cursor: "pointer",
//                   transition: "background-color 0.3s ease",
//                   "&:hover": { backgroundColor: "rgba(0,0,0,0.02)" }
//                 }}
//                 onClick={() => handleSlideClick(i)}
//               >
//                 <Box
//                   sx={{
//                     position: "absolute",
//                     left: 0,
//                     top: 0,
//                     width: { xs: "2px", md: "3px" },
//                     height: "100%",
//                     background:
//                       i === active
//                         ? `linear-gradient(to bottom, black ${progress}%, #ccc ${progress}%)`
//                         : i < active
//                         ? "black"
//                         : "#ccc",
//                     transition: `background 0.4s ${KIA_EASE}`,
//                   }}
//                 />

//                 <Typography
//                   fontFamily="KIAbodyLatinbasic_Bold"
//                   sx={{
//                     color: i === active ? "black" : 
//                            i < active ? "#333" : "#8a8a8a",
//                     transition: `color 0.4s ${KIA_EASE}`,
//                     fontSize: { xs: "0.875rem", sm: "0.9375rem", md: "1rem" },
//                     lineHeight: 1.3
//                   }}
//                 >
//                   {item.title}
//                 </Typography>

//                 <Typography
//                   fontFamily="KIAbodyLatinbasic_Regular"
//                   sx={{
//                     color: i === active ? "black" : 
//                            i < active ? "#666" : "#8a8a8a",
//                     mt: { xs: 0.25, md: 0.5 },
//                     transition: `color 0.4s ${KIA_EASE}`,
//                     fontSize: { xs: "0.75rem", sm: "0.8125rem", md: "0.875rem" },
//                     lineHeight: 1.4,
//                     display: "-webkit-box",
//                     WebkitLineClamp: 2,
//                     WebkitBoxOrient: "vertical",
//                     overflow: "hidden"
//                   }}
//                 >
//                   {item.description}
//                 </Typography>
//               </Box>
//             </SwiperSlide>
//           ))}
//         </Swiper>
//       </Box>
//     </Box>
//   );

//   /* ---------------- MAIN RENDER ---------------- */
//   return (
//     <Box 
//       ref={containerRef}
//       sx={{
//         py: { xs: 4, sm: 5, md: 6 },
//         px: { xs: 2, sm: 3, md: 6 },
//         maxWidth: "1400px",
//         margin: "0 auto",
//         width: "100%",
//         overflow: "hidden"
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: { xs: "column", md: "row" },
//           gap: { xs: 3, sm: 4, md: 6 },
//           alignItems: "stretch",
//           minHeight: { xs: "auto", md: "600px" },
//           width: "100%"
//         }}
//       >
//         {imageOnLeft ? (
//           <>
//             <Box sx={{ 
//               width: { xs: "100%", md: imageWidth },
//               order: { xs: 1, md: 1 },
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center"
//             }}>
//               {MediaSection}
//             </Box>
            
//             <Box sx={{ 
//               width: { xs: "100%", md: textWidth },
//               order: { xs: 2, md: 2 },
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               overflow: "hidden"
//             }}>
//               {ContentSection}
//             </Box>
//           </>
//         ) : (
//           <>
//             <Box sx={{ 
//               width: { xs: "100%", md: textWidth },
//               order: { xs: 2, md: 1 },
//               display: "flex",
//               flexDirection: "column",
//               justifyContent: "center",
//               overflow: "hidden"
//             }}>
//               {ContentSection}
//             </Box>
            
//             <Box sx={{ 
//               width: { xs: "100%", md: imageWidth },
//               order: { xs: 1, md: 2 },
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center"
//             }}>
//               {MediaSection}
//             </Box>
//           </>
//         )}
//       </Box>
//     </Box>
//   );
// }
































import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { Typography, Box, Skeleton, useTheme, useMediaQuery } from "@mui/material";
import { ArrowLeft, ArrowRight } from "iconsax-react";

const KIA_EASE = "cubic-bezier(0.22, 1, 0.36, 1)";

export default function VerticalCarousel({ 
  data, 
  imageOnLeft = true,
  textWidth = "50%",
  imageWidth = "50%"
}) {
  // console.log("VerticalCarousel data:", data);
  
  /* ---------------- HOOKS ---------------- */
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const swiperRef = useRef(null);
  const containerRef = useRef(null);
  const [active, setActive] = useState(0);
  const [progress, setProgress] = useState(0);
  const [loaded, setLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const [swiperSlidesPerView, setSwiperSlidesPerView] = useState(3);
  const [swiperSpaceBetween, setSwiperSpaceBetween] = useState(25);

  /* ---------------- SAFE DATA ---------------- */
  const slides = Array.isArray(data?.carData) ? data.carData : [];
  const total = slides.length;
  const mediaSrc = slides[active]?.media || "";
  
  /* ---------------- AUTO-DETECT VIDEO FUNCTION ---------------- */
  const isVideo = () => {
    if (!mediaSrc) return false;
    
    // Extract filename without query parameters
    const cleanSrc = mediaSrc.split('?')[0].toLowerCase();
    
    // Common video extensions
    const videoExtensions = [
      '.mp4', '.webm', '.ogg', '.mov', '.avi', '.wmv', '.flv', 
      '.mkv', '.m4v', '.mpg', '.mpeg', '.3gp', '.3g2'
    ];
    
    // Check if the URL ends with any video extension
    return videoExtensions.some(ext => cleanSrc.endsWith(ext));
  };

  /* ---------------- RESPONSIVE SETTINGS ---------------- */
  useEffect(() => {
    if (isMobile) {
      setSwiperSlidesPerView(2);
      setSwiperSpaceBetween(15);
    } else if (isTablet) {
      setSwiperSlidesPerView(2.5);
      setSwiperSpaceBetween(20);
    } else {
      setSwiperSlidesPerView(3);
      setSwiperSpaceBetween(25);
    }
  }, [isMobile, isTablet]);

  /* ---------------- EFFECTS ---------------- */
  useEffect(() => {
    if (active >= total && total > 0) {
      setActive(0);
    }
  }, [active, total]);

  useEffect(() => {
    if (!containerRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => setIsInView(entry.isIntersecting),
      { threshold: 0.2 }
    );
    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  // Auto-play logic with responsive interval
  useEffect(() => {
    if (!isInView || total === 0) return;
    
    const interval = isMobile ? 150 : isTablet ? 130 : 120;
    const increment = isMobile ? 8 : isTablet ? 6 : 5;
    
    const timer = setInterval(() => {
      setProgress((p) => {
        if (p >= 100) {
          const nextSlide = (active + 1) % total;
          setActive(nextSlide);
          setProgress(0);
          setLoaded(false);
          
          if (swiperRef.current) {
            let swiperPosition = nextSlide;
            if (nextSlide > total - swiperSlidesPerView && total > swiperSlidesPerView) {
              swiperPosition = total - swiperSlidesPerView;
            }
            swiperRef.current.slideTo(swiperPosition, 600);
          }
          return 0;
        }
        return p + increment;
      });
    }, interval);
    
    return () => clearInterval(timer);
  }, [isInView, total, active, swiperSlidesPerView, isMobile, isTablet]);

  /* ---------------- NAVIGATION FUNCTIONS ---------------- */
  const goNext = () => {
    const nextSlide = (active + 1) % total;
    setActive(nextSlide);
    setProgress(0);
    setLoaded(false);
    
    if (swiperRef.current) {
      let swiperPosition = nextSlide;
      if (nextSlide > total - swiperSlidesPerView && total > swiperSlidesPerView) {
        swiperPosition = total - swiperSlidesPerView;
      }
      swiperRef.current.slideTo(swiperPosition, 500);
    }
  };

  const goPrev = () => {
    const prevSlide = (active - 1 + total) % total;
    setActive(prevSlide);
    setProgress(0);
    setLoaded(false);
    
    if (swiperRef.current) {
      let swiperPosition = prevSlide;
      if (prevSlide > total - swiperSlidesPerView && total > swiperSlidesPerView) {
        swiperPosition = total - swiperSlidesPerView;
      }
      swiperRef.current.slideTo(swiperPosition, 500);
    }
  };

  const handleSlideClick = (index) => {
    setActive(index);
    setProgress(0);
    setLoaded(false);
    
    if (swiperRef.current) {
      let swiperPosition = index;
      if (index > total - swiperSlidesPerView && total > swiperSlidesPerView) {
        swiperPosition = total - swiperSlidesPerView;
      }
      swiperRef.current.slideTo(swiperPosition, 500);
    }
  };

  const handleSwiperChange = (swiper) => {
    const swiperIndex = swiper.activeIndex;
    let actualSlideIndex = swiperIndex;
    
    if (swiperIndex >= total - swiperSlidesPerView && total > swiperSlidesPerView) {
      actualSlideIndex = swiperIndex;
      if (actualSlideIndex >= total) {
        actualSlideIndex = total - 1;
      }
    }
    
    if (actualSlideIndex !== active) {
      setActive(actualSlideIndex);
      setProgress(0);
      setLoaded(false);
    }
  };

  /* ---------------- GUARD ---------------- */
  if (!data || total === 0) return null;

  /* ---------------- UI COMPONENTS ---------------- */
  const MediaSection = (
    <Box 
      position="relative" 
      width="100%" 
      height="100%" 
      minHeight={{ xs: 300, sm: 350, md: 400 }}
      display="flex"
      alignItems="center"
      justifyContent="center"
      sx={{
        overflow: "hidden"
      }}
    >
      {!loaded && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          sx={{ 
            position: "absolute", 
            zIndex: 2
          }}
        />
      )}
      
      {/* AUTO-DETECT: Video or Image based on file extension */}
      {isVideo() ? (
        <video
          key={`video-${active}`}
          src={mediaSrc}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          onCanPlayThrough={() => setLoaded(true)}
          onError={() => setLoaded(true)}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: loaded ? 1 : 0,
            transition: `opacity 0.8s ${KIA_EASE}`
          }}
        />
      ) : (
        <Box
          component="img"
          key={`image-${active}`}
          src={mediaSrc}
          loading="lazy"
          onLoad={() => setLoaded(true)}
          onError={() => setLoaded(true)}
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            opacity: loaded ? 1 : 0,
            transition: `opacity 0.8s ${KIA_EASE}`
          }}
        />
      )}
    </Box>
  );

  const ContentSection = (
    <Box 
      flex="1" 
      p={{ xs: 2, sm: 3, md: 4 }}
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      }}
    >
      {/* Subtitle */}
      <Typography
        color="gray"
        letterSpacing={{ xs: 1, md: 2 }}
        fontFamily="KIAbodyLatinbasic_Bold"
        fontSize={{ xs: "0.75rem", sm: "0.875rem", md: "1rem" }}
        mb={{ xs: 0.5, md: 1 }}
      >
        {data.sub}
      </Typography>

      {/* Title */}
      <Typography
        fontFamily="KIAbodyLatinbasic_Bold"
        sx={{ 
          fontSize: { xs: "18px", sm: "22px", md: "clamp(22px,4vw,30px)" }, 
          my: { xs: 0.5, sm: 1, md: 1.5 },
          lineHeight: { xs: 1.3, md: 1.4 }
        }}
      >
        {data.title}
      </Typography>

      {/* Description */}
      <Typography
        fontFamily="KIAbodyLatinbasic_Regular"
        lineHeight={{ xs: 1.5, md: 1.8 }}
        mb={{ xs: 2, md: 3 }}
        fontSize={{ xs: "0.875rem", sm: "0.9375rem", md: "1rem" }}
      >
        {data.data}
      </Typography>

      {/* Counter + arrows */}
      <Box 
        display="flex" 
        alignItems="center" 
        gap={{ xs: 1.5, md: 2 }} 
        mb={{ xs: 2, md: 3 }}
        flexWrap="wrap"
      >
        <Typography sx={{ 
          px: { xs: 1.5, md: 2 }, 
          py: { xs: 0.25, md: 0.5 }, 
          borderRadius: 20, 
          background: "#f2f2f2",
          fontFamily: "KIAbodyLatinbasic_Bold",
          fontSize: { xs: "0.75rem", md: "0.875rem" }
        }}>
          {active + 1}/{total}
        </Typography>

        <Box display="flex" gap={{ xs: 1, md: 1.5 }}>
          <Box 
            onClick={goPrev}
            sx={{ 
              cursor: "pointer", 
              padding: { xs: "4px", md: "6px" },
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": { 
                backgroundColor: "rgba(0,0,0,0.05)" 
              }
            }}
          >
            <ArrowLeft size={isMobile ? 20 : 24} />
          </Box>
          <Box 
            onClick={goNext}
            sx={{ 
              cursor: "pointer", 
              padding: { xs: "4px", md: "6px" },
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              "&:hover": { 
                backgroundColor: "rgba(0,0,0,0.05)" 
              }
            }}
          >
            <ArrowRight size={isMobile ? 20 : 24} />
          </Box>
        </Box>
      </Box>

      {/* Vertical Swiper */}
      <Box sx={{ 
        height: { xs: 220, sm: 250, md: 300 }, 
        width: "100%",
        overflow: "hidden"
      }}>
        <Swiper
          direction="vertical"
          slidesPerView={swiperSlidesPerView}
          spaceBetween={swiperSpaceBetween}
          modules={[Navigation]}
          onSwiper={(s) => {
            swiperRef.current = s;
          }}
          onSlideChange={handleSwiperChange}
          observer={true}
          observeParents={true}
          initialSlide={0}
          style={{ 
            height: "100%", 
            width: "100%",
            paddingRight: isMobile ? "10px" : "0"
          }}
          touchRatio={0.8}
          resistanceRatio={0.5}
        >
          {slides.map((item, i) => (
            <SwiperSlide key={i}>
              <Box 
                pl={{ xs: 1.5, md: 2 }} 
                pr={{ xs: 0.5, md: 1 }}
                py={{ xs: 0.5, md: 1 }}
                position="relative" 
                width="100%"
                sx={{ 
                  cursor: "pointer",
                  transition: "background-color 0.3s ease",
                  "&:hover": { backgroundColor: "rgba(0,0,0,0.02)" }
                }}
                onClick={() => handleSlideClick(i)}
              >
                <Box
                  sx={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: { xs: "2px", md: "3px" },
                    height: "100%",
                    background:
                      i === active
                        ? `linear-gradient(to bottom, black ${progress}%, #ccc ${progress}%)`
                        : i < active
                        ? "black"
                        : "#ccc",
                    transition: `background 0.4s ${KIA_EASE}`,
                  }}
                />

                <Typography
                  fontFamily="KIAbodyLatinbasic_Bold"
                  sx={{
                    color: i === active ? "black" : 
                           i < active ? "#333" : "#8a8a8a",
                    transition: `color 0.4s ${KIA_EASE}`,
                    fontSize: { xs: "0.875rem", sm: "0.9375rem", md: "1rem" },
                    lineHeight: 1.3
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  fontFamily="KIAbodyLatinbasic_Regular"
                  sx={{
                    color: i === active ? "black" : 
                           i < active ? "#666" : "#8a8a8a",
                    mt: { xs: 0.25, md: 0.5 },
                    transition: `color 0.4s ${KIA_EASE}`,
                    fontSize: { xs: "0.75rem", sm: "0.8125rem", md: "0.875rem" },
                    lineHeight: 1.4,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  }}
                >
                  {item.description}
                </Typography>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );

  /* ---------------- MAIN RENDER ---------------- */
  return (
    <Box 
      ref={containerRef}
      sx={{
        py: { xs: 4, sm: 5, md: 6 },
        px: { xs: 2, sm: 3, md: 6 },
        maxWidth: "1400px",
        margin: "0 auto",
        width: "100%",
        overflow: "hidden"
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: { xs: 3, sm: 4, md: 6 },
          alignItems: "stretch",
          minHeight: { xs: "auto", md: "600px" },
          width: "100%"
        }}
      >
        {imageOnLeft ? (
          <>
            <Box sx={{ 
              width: { xs: "100%", md: imageWidth },
              order: { xs: 1, md: 1 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {MediaSection}
            </Box>
            
            <Box sx={{ 
              width: { xs: "100%", md: textWidth },
              order: { xs: 2, md: 2 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              overflow: "hidden"
            }}>
              {ContentSection}
            </Box>
          </>
        ) : (
          <>
            <Box sx={{ 
              width: { xs: "100%", md: textWidth },
              order: { xs: 2, md: 1 },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              overflow: "hidden"
            }}>
              {ContentSection}
            </Box>
            
            <Box sx={{ 
              width: { xs: "100%", md: imageWidth },
              order: { xs: 1, md: 2 },
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}>
              {MediaSection}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
}